import HTTP from "../HTTP";
import AddressesHelper from "@/API/helpers/addresses";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async destroy(id) {
    try {
      await HTTP.normal.delete(`/addresses/${id}`, id);
    } catch (e) {
      throw e;
    }
  },

  async getByUser(payload) {
    try {
      let results = await HTTP.normal.get(
        `/${payload.type}/${payload.id}/addresses?include=district.city.state.country,district.pricing`
      );
      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw e;
    }
  },

  async create(payload) {
    try {
      let address = await HTTP.normal.post(
        "/addresses",
        AddressesHelper.buildRequestBody(payload)
      );
      return dataFormatter.deserialize(address.data);
    } catch (e) {
      throw e;
    }
  },

  async update(payload) {
    try {
      let data = {
        data: {
          type: "addresses",
          id: payload.id,
          attributes: payload.address,
          relationships: {
            district: {
              data: {
                type: "districts",
                id: payload.district_id
              }
            }
          }
        }
      };

      await HTTP.normal.patch(`/addresses/${payload.id}`, data);
    } catch (e) {
      throw e;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/addresses.js